import { getService } from "VSS/Service";
import { getDefaultWebContext } from "VSS/Context";
import { WebPageDataService } from "VSS/Contributions/Services";

interface IDataProviderResponse<T> {
    errorMessage: string;
    data: T;
}

export async function getDataAsync<T>(dataProviderId: string, requestProperties: any = null): Promise<T> {
    const service = getService(WebPageDataService, getDefaultWebContext());
    const result: IDataProviderResponse<T> = await service.getDataAsync<IDataProviderResponse<T>>(
        dataProviderId,
        /*serviceInstanceId*/ null,
        requestProperties
    );
    if (result.errorMessage && result.errorMessage.length > 0) {
        throw new Error(result.errorMessage);
    } else {
        return result.data;
    }
}
